
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"21","height":"20","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M21 10l-2.148-2.65.12-3.495-3.341-.843L13.72 0 10.5 1.205 7.278 0 5.37 2.892l-3.34.963.119 3.494L0 10l2.148 2.771-.12 3.494 3.341.843L7.28 20l3.221-1.205L13.722 20l1.909-3.012 3.34-.964-.119-3.494L21 10zm-10.62 3.012l-1.43 1.446-1.432-1.446-2.506-2.53 1.432-1.446 2.506 2.53 5.608-5.662 1.432 1.445-5.608 5.663z","fill":"url(#paint0_linear_194_191)"}}),_c('defs',[_c('linearGradient',{attrs:{"id":"paint0_linear_194_191","x1":"0","y1":"0","x2":"21.173","y2":"18.056","gradientUnits":"userSpaceOnUse"}},[_c('stop',{attrs:{"stop-color":"#D89F00"}}),_c('stop',{attrs:{"offset":".474","stop-color":"#FCD035"}}),_c('stop',{attrs:{"offset":".776","stop-color":"#D89F00"}})])])])
          )
        }
      }
    